import React from "react";
import { styled } from "@stitches/react";
import { FaGem } from "react-icons/fa";
import { Box } from "../../primitives";

const Wrapper = styled(Box, {
  position: "relative",
  width: "40px",
  height: "40px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const Icon = styled(FaGem, {
  color: "#2563eb",
  fontSize: "30px",
});

const Overlay = styled("span", {
  position: "absolute",
  color: "white",
  fontSize: "14px",
  fontWeight: "bold",
});

export const ReversIcon = () => (
  <Wrapper>
    <Icon />
    <Overlay>R</Overlay>
  </Wrapper>
);
